<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <el-form :inline="true" label-position="left" style="margin-bottom: 5px" @submit.native.prevent>
          <el-form-item label-width="90px" :label="$t('baseInfo.operation.lobType')">
            <!--业务类型-->
            <el-select
              v-model="searchConditions.lob"
              :placeholder="$t('common.tips.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option
                :label="$t('common.tips.pleaseChoose')"
                value=""
              />
              <el-option
                v-for="item in lobArray"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="90px" :label="$t('baseInfo.operation.operationType')">
            <!--操作要求类型-->
            <el-select
              v-model="searchConditions.operationRequirementType"
              :placeholder="$t('common.tips.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option
                :label="$t('common.tips.pleaseChoose')"
                value=""
              />
              <el-option
                v-for="item in operationRequirementTypeArray"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label-width="$selectByLang('90px', '90px', '90px', '180px', '180px', '180px')" :label="$t('baseInfo.operation.contentDescription')">
            <el-input
              v-model="searchConditions.contentDescription"
              style="width: 260px"
              size="mini"
              :placeholder="$t('baseInfo.operation.enterContentDescription')"
              @change="searchConditions.pageNum=1"
              @keyup.enter.native="fetchSysOperationRequirementDescriptionList"
            />
          </el-form-item>
          <div>
            <el-button size="mini" type="primary" @click="fetchSysOperationRequirementDescriptionList">{{
              $t('common.btn.query') }}
            </el-button>
            <el-button size="mini" type="primary" @click="popOperationPortAddFormDialog">{{ $t('common.btn.new') }}
            </el-button>
            <el-button size="mini" type="primary" @click="popOperationPortEditFormDialog">{{ $t('common.btn.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </el-form>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100301"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-side-bar="false"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            config-module="100301"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchSysOperationRequirementDescriptionList"
          />
        </div>
      </div>
    </div>
    <!-- 操作要求描述维护 -->
    <el-dialog
      v-if="isShowOperationMaintain"
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowOperationMaintain"
      :title="$t('baseInfo.operation.operationMaintain')"
      inline-message
      width="500px"
    >
      <el-form ref="operationForm" :model="operationForm" label-width="120px" label-position="right">
        <el-form-item :label="$t('baseInfo.operation.code')" prop="code">
          <el-input v-model="operationForm.code" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.operation.lob')" prop="lob">
          <!--操作要求类型-->
          <cargo-advance-select
            filterable
            :headers="['name']"
            :fields="['name']"
            :callback-params="{key:'lob'}"
            callback-method-type="code"
            :default-value="operationForm.lob"
            tag-value="code"
            tag-name="name"
            :static-options="lobArray"
            :filter-tag-names="['name']"
            style="width:100%;"
            @parentCallBack="getValueFromChild"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.operation.operationRequirementType')" prop="operationRequirementType">
          <cargo-advance-select
            filterable
            :headers="['name']"
            :fields="['name']"
            :callback-params="{key:'operationRequirementType'}"
            callback-method-type="code"
            :default-value="operationForm.operationRequirementType"
            tag-value="code"
            tag-name="name"
            :static-options="operationRequirementTypes"
            :filter-tag-names="['name']"
            style="width:100%;"
            @parentCallBack="getValueFromChild"
          />
        </el-form-item>
        <!-- B2B网站 -->
        <el-form-item v-if="isAirExportHandlingInfo" :label="$t('Tool.b2bWebsite')">
          <el-checkbox v-model="operationForm.isB2bPageVisible">{{ $t('Tool.pageDisplay') }}</el-checkbox>
          <el-checkbox v-model="operationForm.isB2bFieldRequired">{{ $t('Tool.required') }}</el-checkbox>
        </el-form-item>
        <!-- B2B网站显示 -->
        <el-form-item v-if="isAirExportHandlingInfo" :label="$t('Tool.b2bWebsiteDisplay')">
          <el-radio-group v-model="b2bOrderContentLanguage">
            <el-radio-button label="b2bContentZh">{{ $t('Tool.Chinese') }}</el-radio-button>
            <el-radio-button label="b2bContentEn">{{ $t('Tool.English') }}</el-radio-button>
            <el-radio-button label="b2bContentJp">{{ $t('Tool.Japanese') }}</el-radio-button>
          </el-radio-group>
          <el-input v-model="operationForm[b2bOrderContentLanguage]" :disabled="!operationForm.isB2bPageVisible" style="margin-top: 10px;" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.operation.contentDescription')" prop="contentDescription">
          <el-input v-model="operationForm.contentDescription" type="textarea" :maxlength="512" :rows="6" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.operation.remark')" prop="remark">
          <el-input v-model="operationForm.remarks" type="textarea" :maxlength="255" :rows="6" size="mini" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submitOperationRequirementDescription">{{ $t('common.btn.save')
        }}
        </el-button>
        <el-button size="mini " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import URL from '@/api/urlTranslator'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import OperationRequirementType from '@/class/cargo/model/parameters/OperationRequirementType'
import {
  getSysOperationRequirementDescriptionList,
  batchDelOperationRequirementDescription,
  getSysOperationRequirementOptionList,
  updateOperationRequirementDescription,
  addOperationRequirementDescription
} from '@/api/operation'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'Operation',
  components: { cargoAdvanceSelect },
  data() {
    return {
      searchConditions: {
        contentDescription: '', // 模糊查询名称
        lob: '',
        operationRequirementType: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      gridParams: {},
      rowData: [],
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.operation.code'),
          field: 'code',
          width: 400
        },
        {
          headerName: this.$t('baseInfo.operation.lob'),
          field: 'lob',
          cellRenderer: params => {
            const lob = this.lobArray.find(item => {
              return item.code === params.value
            })
            return lob ? lob.name : this.$t('Information.UnknownType')
          },
          width: 400
        },
        {
          headerName: this.$t('baseInfo.operation.operationRequirementType'),
          field: 'operationRequirementType',
          cellRenderer: params => {
            const operationRequirementType = this.operationRequirementTypeArray.find(item => {
              return item.code === params.value
            })
            return operationRequirementType ? operationRequirementType.name : this.$t('Information.UnknownType')
          },
          width: 400
        },
        {
          headerName: this.$t('baseInfo.operation.contentDescription'),
          field: 'contentDescription',
          width: 400
        }],
      isShowOperationMaintain: false,
      operationMaintainTitle: '',
      b2bOrderContentLanguage: 'b2bContentZh',
      operationForm: {
        code: '',
        lob: '',
        operationRequirementType: '',
        contentDescription: '',
        remarks: '',
        version: '',
        descriptionId: '',
        isB2bPageVisible: true,
        isB2bFieldRequired: false,
        b2bContentZh: '',
        b2bContentEn: '',
        b2bContentJp: ''
      },
      lobArray: [
        {
          code: 'SE',
          name: this.$t('Information.SeaExport')
        },
        {
          code: 'AE',
          name: this.$t('Information.AirExport')
        }
      ],
      fullscreenLoading: null,
      operationRequirementTypeArray: []
    }
  },
  computed: {
    url() {
      return URL
    },
    operationRequirementTypes() {
      return (this.operationForm.lob && this.operationForm.lob === 'AE') ? this.operationRequirementTypeArray : this.operationRequirementTypeArray.filter(item => Number(item.code) !== OperationRequirementType.HANDLING_INFO.code)
    },
    // 当业务类型为【空运出口】且操作类型为【Handling Info】
    isAirExportHandlingInfo() {
      return this.operationForm.lob === 'AE' && this.operationForm.operationRequirementType === OperationRequirementType.HANDLING_INFO.code
    }
  },
  watch: {
    // 当业务类型为【空运出口】且操作类型为【Handling Info】
    // 重制参数
    isAirExportHandlingInfo(value) {
      if (!value) {
        this.$set(this.operationForm, 'isB2bPageVisible', true)
        this.$set(this.operationForm, 'isB2bFieldRequired', false)
        this.$set(this.operationForm, 'b2bContentZh', '')
        this.$set(this.operationForm, 'b2bContentEn', '')
        this.$set(this.operationForm, 'b2bContentJp', '')
        this.b2bOrderContentLanguage = 'b2bContentZh'
      }
    }
  },
  mounted() {
    // 初始化操作类型枚举
    this.getOperationRequirementTypeList()
    // 初始化操作描述集合
    this.fetchSysOperationRequirementDescriptionList()
  },
  methods: {
    // 获取操作要求列表
    fetchSysOperationRequirementDescriptionList() {
      const self = this
      self.fullscreenLoading = getLoading()
      const params = { ...this.searchConditions }
      getSysOperationRequirementDescriptionList(params).then(res => {
        self.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        self.fullscreenLoading.close()
      }).catch(() => {
        self.fullscreenLoading.close()
      })
    },
    // 操作描述新增弹窗
    popOperationPortAddFormDialog() {
      this.operationForm = {
        isB2bPageVisible: true,
        isEdit: false
      }
      this.isShowOperationMaintain = true
    },
    // 操作描述编辑弹窗
    popOperationPortEditFormDialog() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          console.log('getGridSelected(this.gridOptions)', getGridSelected(this.gridOptions)[0])
          self.operationForm = { ...getGridSelected(this.gridOptions)[0] }
          this.operationForm.isEdit = true
          self.isShowOperationMaintain = true
        }
      })
    },
    toBatchDel() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        }
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          batchDelOperationRequirementDescription(ids).then(res => {
            self.fetchSysOperationRequirementDescriptionList()
            this.$message.success(this.$t('common.tips.deleteSuccess'))
          }).catch(() => {
            this.$message.info(this.$t('common.tips.deleteSuccess'))
          })
        }).catch(() => {
          this.$message.error(this.$t('common.tips.cancelDelete'))
        })
      })
    },
    getAirPortSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        return null
      }
      return selectedRows
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.isShowOperationMaintain = false
      this.operationForm = {}
    },
    // 获取操作类型枚举
    getOperationRequirementTypeList() {
      getSysOperationRequirementOptionList().then(res => {
        this.operationRequirementTypeArray = res.data
      }).catch(() => {
      })
    },
    // 获取业务类型枚举
    // getOperationLobTypeList() {
    //   getSysOperationLobOptionList().then(res => {
    //     // this.lobArray = res.data
    //   }).catch(() => {
    //   })
    // },
    toCheckOperationForm(opt) {
      const { code, lob, operationRequirementType, contentDescription } = opt
      let errorMsg = ''
      if (!code) {
        errorMsg += this.$t('Information.CodeCannotBeEmpty')
      }
      if (!lob) {
        errorMsg += this.$t('Information.BusinessTypeCannotBeEmpty')
      }
      if (!operationRequirementType) {
        errorMsg += this.$t('Information.OperationTypeCannotBeEmpty')
      }
      if (!contentDescription) {
        errorMsg += this.$t('Information.ContentDescriptionCannotBeEmpty')
      }

      // 校验B2B网站必填
      if (this.isAirExportHandlingInfo && this.operationForm.isB2bPageVisible) {
        if (!this.operationForm.b2bContentZh || !this.operationForm.b2bContentEn || !this.operationForm.b2bContentJp) {
          errorMsg += this.$t('Information.b2bWebsiteDisplayNotEmpty')
        }
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return
      } else {
        return true
      }
    },
    submitOperationRequirementDescription() {
      // 校验操作表单
      if (!this.toCheckOperationForm(this.operationForm)) {
        return
      }

      if (!this.operationForm.isEdit) {
        this.toAddOperationRequirementDescription()
      } else {
        this.editOperationRequirementDescription()
      }
    },
    // 编辑基础资料操作
    editOperationRequirementDescription() {
      this.fullscreenLoading = getLoading()
      updateOperationRequirementDescription(this.operationForm).then(res => {
        this.isShowOperationMaintain = false
        this.fullscreenLoading.close()
        this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
      }).then(() => {
        this.fetchSysOperationRequirementDescriptionList()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 新增基础资料操作
    toAddOperationRequirementDescription() {
      addOperationRequirementDescription(this.operationForm).then(res => {
        this.isShowOperationMaintain = false
        this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      }).then(() => {
        this.fetchSysOperationRequirementDescriptionList()
      })
    },
    getValueFromChild(obj) {
      this.$set(this.operationForm, obj.key, obj.value)
      if (obj.key === 'lob') {
        this.getOperationRequirementTypeList()
        if (obj.value === 'SE' && this.operationForm.operationRequirementType === OperationRequirementType.HANDLING_INFO.code) {
          this.$set(this.operationForm, 'operationRequirementType', 0)
        }
      } else if (obj.key === 'operationRequirementType') {
        if (obj.value === OperationRequirementType.HANDLING_INFO.code && this.operationForm.lob === 'SE') {
          this.$set(this.operationForm, 'operationRequirementType', 0)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
